import { Alert, Snackbar, Stack, Typography, styled } from "@mui/material";
import { AlertVariant, type AlertEntry } from "./Alerts";

const severityColors: Record<string, string> = {
  success: "#07A956",
  info: "#0A68F1",
  warning: "#FFC107",
  error: "#FF4242",
};

const CustomAlert = styled(Alert)<{ severity?: string }>(({ theme, severity }) => ({
  backgroundColor: "#fff",
  borderTop: `4px solid ${severityColors[severity ?? "info"]}`,
  color: theme.palette.text.primary,
  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
  borderRadius: '3px'
}));

export type AlertPanelProps = {
  alerts: AlertEntry[];
  onCloseAlert: (id: number) => void;
};

export function AlertPanel({ alerts, onCloseAlert }: AlertPanelProps) {
  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      {alerts.map(({ id, variant, message, description }, index) => (
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          open={true}
          onClose={() => onCloseAlert(id)}
          message={description && <Typography variant="body1">{description}</Typography>}
          key={id}
        >
          <CustomAlert
            key={id}
            data-testid={index === 0 ? "last-alert" : undefined}
            severity={AlertVariant[variant]}
            onClose={() => onCloseAlert(id)}
          >
            <>{message}</>
            {description && <Typography variant="body1">{description}</Typography>}
          </CustomAlert>
        </Snackbar>
      ))}
    </Stack>
  );
}